
import { headers } from "../utils/helpers";


async function fetchModelV2(makeId, year, search) {
    search.length > 0 ? this.isLoading = false : this.isLoading = true;
    try {
        const response = await fetch(`/api/v2/vehicle-model/?make=${makeId}&year=${year}&search=${search}`, {
            method: 'GET',
            headers: headers
        });
        const data = await response.json();
        if (data?.success === false) {
            this.showError(data.error)
            return
        }
        this.isLoading = false;
        this.modelData = data;
    } catch (error) {
        this.showError(error);
    }
    this.isLoading = false;
}


async function fetchMakeV2(year, search) {
    search.length > 0 ? this.isLoading = false : this.isLoading = true;
    try {
        const response = await fetch(`/api/v2/vehicle-make/?year=${year}&search=${search}`, {
            method: "GET",
            headers: headers,
        });
        const data = await response.json();
        if (data?.success === false) {
            this.showError(data.error)
            return
        }
        this.isLoading = false;
        this.makeData = data;
    } catch (e) {
        this.showError(e)
    };
    this.isLoading = false;
}

async function fetchVariantV2(modelId, year, search) {
    search.length > 0 ? this.isLoading = false : this.isLoading = true;
    try {
        const response = await fetch(`/api/v2/vehicle-variant/?model=${modelId}&year=${year}&search=${search}`, {
            method: 'GET',
            headers: headers
        });
        const data = await response.json();
        if (data?.success === false) {
            this.showError(data.error)
            return
        }
        this.isLoading = false;
        this.variantData = data;
    } catch (error) {
        this.showError(error);
    }
    this.isLoading = false;
}


export { fetchMakeV2, fetchModelV2, fetchVariantV2 };